const maskElement = document.getElementById('drawer-mask');
const drawerElement = document.getElementById('drawer-content');
const drawerWrapperElement = document.getElementById('drawer-wrapper');
const header = document.querySelector('.site-header');

class PanelManager {
  constructor(initialState, transitions) {
    this.state = initialState;
    this.transitions = transitions;
    this.panels = [];
    document.querySelectorAll('[data-panel]').forEach((x) => {
      this.panels[x.dataset.panel] = x;
    });
    this.measureScreen();
    this.registerPanelEvents();
  }

  measureScreen() {
    this.vhElement = document.createElement('div');
    this.vhElement.classList.add('h-screen', 'fixed');
    document.body.appendChild(this.vhElement);
    this.dvhElement = document.createElement('div');
    this.dvhElement.classList.add('h-dvh', 'fixed');
    document.body.appendChild(this.dvhElement);
    this.addressBarHeight = this.vhElement.clientHeight - this.dvhElement.clientHeight;
    this.pageHeight = window.innerHeight;
    //document.body.removeChild(vhElement);
    //document.body.removeChild(dvhElement);
  }

  registerPanelEvents() {
    document.addEventListener('click', (e) => {
      const target = e.target.closest('[data-panel-transition]');
      if (target) {
        e.preventDefault();
        e.stopPropagation();
        this.dispatch(target.dataset.panelTransition, target);
      }
      const link = e.target.closest('a[href="#bookanappointment"], a[href$="pages/book-an-appointment"]');
      if (link) {
        e.preventDefault();
        e.stopPropagation();
        this.dispatch('OPEN_APPOINTMENT', link);
      }
    });
  }

  dispatch(event, triggerElement = null) {
    console.log('Dispatched: ', event, triggerElement);
    const { state, transitions } = this;
    const transition = transitions[state]?.[event];
    if (transition) {
      const targetState = event.target;
      const incomingPanelName = transition.panel ?? 'idle';
      const incomingPanel = this.panels[incomingPanelName] ?? false;
      const previousPanel = this.activePanel;

      if (typeof transition.action === 'function') {
        console.log('transition with action');
        transition.action(triggerElement, this.activePanel);
        this.activePanel = false;
      } else if (incomingPanel) {
        console.log('transition to panel');
        // incomingPanel.activate(triggerElement);
        incomingPanel.transitionFrom(state, targetState, triggerElement, previousPanel);
        this.activePanel = incomingPanel;
      } else if (previousPanel) {
        console.log('transition from panel', previousPanel);
        previousPanel.deactivate();
        this.activePanel = false;
      }

      this.state = transition.target;
      // if (targetPanel) {
      //   Object.entries(this.panels).forEach((x) => {
      //     x[1].classList.add('hidden');
      //   });
      //   targetPanel.classList.remove('hidden');
      // }
      //
      // this.state = transition.target;
      // if (typeof transition.action === 'function') {
      //   transition.action(triggerElement);
      // }
    }
  }
}

function mouseOverDrawer() {
  drawerWrapperElement.classList.add('drawer-open'); // @todo - what?
}

// Define the actions
const actions = {
  openRightFullNav: (previousPanel) => {
    console.log('openRightFullNav');

    return new Promise((resolve) => {
      maskElement.show();
      drawerElement.className =
        'drawer-inner transition-all absolute inset-y-0 z-75 w-full translate-x-full ' +
        'md:right-0 bg-white duration-600 md:w-25';
      // un-hide container
      drawerWrapperElement.style.zIndex = '100';
      drawerWrapperElement.classList.remove('hidden');
      // set transition state
      requestAnimationFrame(() => {
        drawerElement.classList.remove('translate-x-full');
        maskElement.classList.replace('opacity-0', 'opacity-60');
        drawerElement.addEventListener('mouseover', mouseOverDrawer);
        waitForTransitionEnd(drawerElement).then(() => {
          resolve();
        });
      });
      // setTimeout(() => {
      //   let filtersPanel = drawerElement.querySelector('filters-panel');
      //   if (filtersPanel) {
      //     trapFocus(filtersPanel, filtersPanel.querySelector('button'));
      //   }
      // }, 500);
    });
  },
  openRightBottomNav: (triggerElement, previousPanel) => {
    console.log('openRightBottomNav');

    return new Promise((resolve) => {
      maskElement.show();
      // set start state
      drawerWrapperElement.style.zIndex = '100';
      drawerElement.className =
        'drawer-menu transition-top transition-left absolute bottom-0\n' +
        '      z-75 mt-16\n' +
        '      max-h-[calc(100dvh-50px)] w-full translate-y-full\n' +
        '      bg-white\n' +
        '      duration-600\n' +
        '      md:right-0\n' +
        '      md:top-0 md:mt-0 md:max-h-dvh md:w-25 md:translate-x-full\n' +
        '      md:translate-y-0';
      // un-hide container
      drawerWrapperElement.classList.remove('hidden');
      // set transition state
      requestAnimationFrame(() => {
        drawerElement.classList.remove('md:translate-x-full');
        drawerElement.classList.remove('translate-y-full');
        maskElement.classList.replace('opacity-0', 'opacity-60');
        waitForTransitionEnd(drawerElement).then(() => {
          resolve();
        });
      });

      drawerElement.addEventListener('mouseover', mouseOverDrawer);
    });
  },
  closeLeftNav: (triggerElement, previousPanel) => {
    return new Promise((resolve) => {
      console.log('closeLeftNav');
      drawerWrapperElement.classList.remove('drawer-open');
      drawerElement.removeEventListener('mouseover', mouseOverDrawer);
      maskElement.hide();
      drawerElement.classList.add('-translate-x-full');
      maskElement.classList.replace('opacity-60', 'opacity-0');
      setTimeout(() => {
        header.classList.remove('desktop-drawer-open');
        header.querySelectorAll('[data-panel-transition]').forEach((x) => {
          x.classList.remove('!text-black');
        });
      }, 150);
      waitForTransitionEnd(maskElement).then(() => {
        drawerWrapperElement.style.zIndex = '';
        drawerWrapperElement.classList.add('hidden');
        drawerWrapperElement.classList.remove('level-2-active');
        window.clearFocusQueue();
        if (previousPanel) {
          previousPanel.deactivate();
        }
        resolve();
      });
    });
  },
  closeLeftFullNav: (triggerElement, previousPanel) => {
    console.log('closeLeftFullNav');
    drawerWrapperElement.classList.remove('drawer-open');
    maskElement.hide();
    drawerElement.classList.add('-translate-x-full');
    maskElement.classList.replace('opacity-60', 'opacity-0');
    setTimeout(() => {
      header.classList.remove('desktop-drawer-open');
      header.querySelectorAll('[data-panel-transition]').forEach((x) => {
        x.classList.remove('!text-black');
      });
    }, 150);
    waitForTransitionEnd(maskElement).then(() => {
      drawerWrapperElement.style.zIndex = '';
      drawerWrapperElement.classList.add('hidden');
      window.clearFocusQueue();
      if (previousPanel) {
        previousPanel.deactivate();
      }
    });
  },
  closeRightFullNav: (triggerElement, previousPanel) => {
    console.log('closeRightFullNav');
    drawerWrapperElement.classList.remove('drawer-open');
    drawerElement.removeEventListener('mouseover', mouseOverDrawer);
    drawerWrapperElement.classList.remove('drawer-open');
    maskElement.hide();
    drawerElement.classList.add('translate-x-full');
    maskElement.classList.replace('opacity-60', 'opacity-0');

    waitForTransitionEnd(maskElement).then(() => {
      drawerWrapperElement.style.zIndex = '';
      drawerWrapperElement.classList.add('hidden');
      window.clearFocusQueue();
      if (previousPanel) {
        previousPanel.deactivate();
      }
    });
  },
  closeRightBottomNav: (triggerElement, previousPanel) => {
    console.log('closeRightBottomNav');
    return new Promise((resolve) => {
      drawerWrapperElement.classList.remove('drawer-open');
      drawerElement.removeEventListener('mouseover', mouseOverDrawer);
      maskElement.hide();
      // set start state
      drawerElement.className =
        'drawer-menu transition-all absolute bottom-0\n' +
        '      z-65 mt-16\n' +
        '      max-h-[calc(100dvh-50px)] w-full translate-y-full\n' +
        '      bg-white \n' +
        '      duration-600\n' +
        '      md:right-0\n' +
        '      md:top-0 md:mt-0 md:max-h-dvh md:w-25 md:translate-x-full\n' +
        '      md:translate-y-0';
      // un-hide container
      //drawerWrapperElement.classList.remove('hidden');
      // set transition state

      drawerElement.classList.add('tablet:translate-x-full');
      drawerElement.classList.add('translate-y-full');
      maskElement.classList.replace('opacity-60', 'opacity-0');
      // cleanup
      waitForTransitionEnd(maskElement).then(() => {
        drawerWrapperElement.style.zIndex = '';
        drawerWrapperElement.classList.add('hidden');
        window.clearFocusQueue();
        if (previousPanel) {
          previousPanel.deactivate();
        }
        resolve();
      });
    });
  },
  closeRightLeftNav: (triggerElement, previousPanel) => {
    console.log('closeRightLeftNav');
    drawerWrapperElement.classList.remove('drawer-open');
    drawerElement.removeEventListener('mouseover', mouseOverDrawer);
    maskElement.hide();
    drawerElement.classList.add('lg:translate-x-full');
    drawerElement.classList.add('-translate-x-full');
    maskElement.classList.replace('opacity-60', 'opacity-0');
    waitForTransitionEnd(maskElement).then(() => {
      drawerWrapperElement.style.zIndex = '';
      drawerWrapperElement.classList.add('hidden');
      window.clearFocusQueue();
      if (previousPanel) {
        previousPanel.deactivate();
      }
    });
  },
};

// Define the state machine transitions
const transitions = {
  idle: {
    OPEN_SHOP: { target: 'shopActive', panel: 'menu' },
    OPEN_SEARCH: { target: 'searchActive', panel: 'search' },
    OPEN_ACCOUNT: { target: 'accountActive', panel: 'account' },
    OPEN_LOCATION: { target: 'locationActive', panel: 'location' },
    OPEN_APPOINTMENT: {
      target: 'appointmentActive',
      action: (triggerElement) => {
        const mask = document.getElementById('appointment-drawer-mask');
        mask.show();
        mask.classList.remove('hidden');
        requestAnimationFrame(() => {
          mask.classList.replace('opacity-0', 'opacity-60');
          setTimeout(() => {
            window.booxiController.open('booking_form');
          }, 300);
        });
      },
    },
    OPEN_FILTER: { target: 'filterActive', panel: 'filters' },
    OPEN_NEWSLETTER: { target: 'newsletterActive', panel: 'newsletter' },
    OPEN_COOKIE: { target: 'cookieActive' },
    OPEN_ADDTOCART: { target: 'addToCartActive', panel: 'add-to-cart' },
    OPEN_SIZECHART: { target: 'productDetailsActive', panel: 'sizechart' },
    OPEN_CART: { target: 'cartActive', panel: 'cart' },
    OPEN_CONTACT: { target: 'contactActive', panel: 'contact' },
    OPEN_ENQUIRY: { target: 'enquiryActive', panel: 'enquiry' },
    OPEN_ENQUIRY_INSTANT: {
      target: 'enquiryActive',
      action: (triggerElement, previousPanel) => {
        window.panelManager.panels['enquiry'].transitionFrom(
          'enquirySubmission',
          'enquiryActive',
          triggerElement,
          previousPanel,
        );
      },
    },
    OPEN_PRODUCTDETAILS: { target: 'productDetailsActive', panel: 'product-details' },
    OPEN_SELECTCARAT: { target: 'selectCaratActive', panel: 'select-carat' },
    OPEN_STYLINGADVICE: { target: 'productDetailsActive', panel: 'styling-advice' },
    OPEN_DELIVERYRETURNS: { target: 'productDetailsActive', panel: 'delivery-returns' },
  },
  shopActive: {
    CLOSE_PANEL: {
      target: 'idle',
      action: (triggerElement, previousPanel) => {
        actions.closeLeftNav(triggerElement, previousPanel).then(() => {
          let target = window.matchMedia('(min-width: 1199px)').matches
            ? document.querySelector('desktop-nav-drawer')
            : document.querySelector('mobile-nav-drawer');
          target.dispatchEvent(new CustomEvent('drawer:close'));
          window.dispatchEvent(new CustomEvent('drawer:close'));
        });
      },
    },
    OPEN_SHOP: { target: 'shopActive', panel: 'menu' },
    OPEN_ACCOUNT: { target: 'accountActive', panel: 'account' },
    OPEN_SEARCH: { target: 'searchActive', panel: 'search' },
    OPEN_CONTACT: { target: 'contactActive', panel: 'contact' },
    OPEN_APPOINTMENT: {
      target: 'appointmentActive',
      action: (triggerElement) => {
        const mask = document.getElementById('appointment-drawer-mask');
        drawerWrapperElement.classList.remove('drawer-open');
        drawerElement.removeEventListener('mouseover', mouseOverDrawer);
        drawerElement.classList.add('-translate-x-full');
        setTimeout(() => {
          header.classList.remove('desktop-drawer-open');
          header.querySelectorAll('[data-panel-transition]').forEach((x) => {
            x.classList.remove('!text-black');
          });
        }, 150);
        waitForTransitionEnd(drawerElement).then(() => {
          drawerWrapperElement.style.zIndex = '';
          drawerWrapperElement.classList.add('hidden');
          drawerWrapperElement.classList.remove('level-2-active');
          window.clearFocusQueue();
          maskElement.hide();
          maskElement.style.transition = 'none';
          maskElement.classList.replace('opacity-60', 'opacity-0');
          mask.show();
          mask.classList.remove('hidden');
          requestAnimationFrame(() => {
            maskElement.style.transition = '';
            mask.style.transition = 'none';
            mask.classList.replace('opacity-0', 'opacity-60');
            setTimeout(() => {
              mask.style.transition = '';
              window.booxiController.open('booking_form');
            }, 300);
          });
        });
      },
    },
  },
  searchActive: {
    CLOSE_PANEL: { target: 'idle', action: actions.closeLeftNav },
    OPEN_SHOP: {
      target: 'shopActive',
      panel: 'menu',
    },
  },
  accountActive: {
    CLOSE_PANEL: { target: 'idle', action: actions.closeRightLeftNav },
    OPEN_SHOP: { target: 'shopActive', panel: 'menu' },
    OPEN_REGISTER: { target: 'registerActive', panel: 'account-register' },
  },
  registerActive: {
    CLOSE_PANEL: { target: 'idle', action: actions.closeRightFullNav, panel: 'account' },
    OPEN_ACCOUNT: { target: 'accountActive', panel: 'account' },
  },
  selectCaratActive: {
    CLOSE_PANEL: { target: 'idle', action: actions.closeRightBottomNav },
  },
  locationActive: {
    CLOSE_PANEL: { target: 'idle', action: actions.closeRightBottomNav },
  },
  appointmentActive: {
    CLOSE_PANEL: {
      target: 'idle',
      action: (triggerElement, previousPanel) => {
        const mask = document.getElementById('appointment-drawer-mask');
        mask.classList.remove('z-100');
        mask.classList.replace('opacity-60', 'opacity-0');
        waitForTransitionEnd(mask).then(() => {
          mask.hide();
          mask.classList.add('hidden');
          window.releaseFocus();
        });
      },
    },
  },
  filterActive: {
    CLOSE_PANEL: { target: 'idle', action: actions.closeRightFullNav },
  },
  newsletterActive: {
    CLOSE_PANEL: {
      target: 'idle',
      action: (triggerElement, previousPanel) => {
        actions.closeRightBottomNav(triggerElement, previousPanel).then(() => {
          window.releaseFocus();
          const newsletter = document.querySelector('newsletter-panel');
          if (newsletter) {
            newsletter.close();
          }
          if (previousPanel) {
            previousPanel.deactivate();
          }
        });
      },
    },
  },
  cookieActive: {
    CLOSE_PANEL: { target: 'idle' },
  },
  addToCartActive: {
    CLOSE_PANEL: { target: 'idle', action: actions.closeRightBottomNav },
    OPEN_CART: { target: 'cartActive', panel: 'cart' },
    OPEN_SIZECHART: { target: 'addToCartSizeActive', panel: 'sizechart' },
  },
  addToCartSizeActive: {
    OPEN_SIZECHART: { target: 'productDetailsActive', panel: 'sizechart' },
    OPEN_STYLINGADVICE: { target: 'productDetailsActive', panel: 'styling-advice' },
    OPEN_DELIVERYRETURNS: { target: 'productDetailsActive', panel: 'delivery-returns' },
    OPEN_PRODUCTDETAILS: { target: 'productDetailsActive', panel: 'product-details' },
    OPEN_ADDTOCART: { target: 'productDetailsActive', panel: 'add-to-cart' },
    OPEN_HOWTOMEASURE: { target: 'productDetailsActive', panel: 'how-to-measure' },
    CLOSE_PANEL: { target: 'addToCartActive', panel: 'add-to-cart' },
  },
  cartActive: {
    CLOSE_PANEL: { target: 'idle', action: actions.closeRightBottomNav },
  },
  contactActive: {
    CLOSE_PANEL: { target: 'idle', action: actions.closeRightFullNav },
    OPEN_ENQUIRY: { target: 'enquiryActive', panel: 'enquiry' },
    OPEN_CHAT: {
      target: 'idle',
      action: (triggerElement, previousPanel) => {
        const gorgias = document.querySelector('gorgias-chat');
        if (gorgias && gorgias.isLive()) {
          actions.closeRightFullNav();
          setTimeout(() => {
            gorgias.openChat();
          }, 600);
        } else {
          panelManager.dispatch('OPEN_ENQUIRY');
        }
      },
    },
  },
  productDetailsActive: {
    CLOSE_PANEL: { target: 'idle', action: actions.closeRightBottomNav },
    OPEN_SIZECHART: { target: 'productDetailsActive', panel: 'sizechart' },
    OPEN_STYLINGADVICE: { target: 'productDetailsActive', panel: 'styling-advice' },
    OPEN_DELIVERYRETURNS: { target: 'productDetailsActive', panel: 'delivery-returns' },
    OPEN_PRODUCTDETAILS: { target: 'productDetailsActive', panel: 'product-details' },
    OPEN_ADDTOCART: { target: 'productDetailsActive', panel: 'add-to-cart' },
    OPEN_HOWTOMEASURE: { target: 'productDetailsActive', panel: 'how-to-measure' },
    OPEN_CONTACT: { target: 'contactActive', panel: 'contact' },
  },
  enquiryActive: {
    CLOSE_PANEL: { target: 'idle', action: actions.closeRightFullNav },
    OPEN_CONTACT: { target: 'contactActive', panel: 'contact' },
  },
};

// Initialize the state machine
const panelManager = new PanelManager('idle', transitions);
window.panelManager = panelManager;

maskElement.addEventListener('click', (e) => {
  panelManager.dispatch('CLOSE_PANEL', e.currentTarget);
});
